import { render } from "./viewOnl.vue?vue&type=template&id=72e0cf3c"
import script from "./viewOnl.vue?vue&type=script&lang=js"
export * from "./viewOnl.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__